"use client";

import React from "react";
import { StyledSection } from "./howItWorks.styles";
import { trackEvent } from '@/lib/track';

export interface IHowItWorksStep {
  title: string;
  body: string;
}

interface IHowItWorksProps {
  title?: string;
  eyebrow?: string;
  steps: IHowItWorksStep[];
  ctaHref?: string;
  ctaText?: string;
  eventName?: string;
}

export const HowItWorks = ({
  title = "How it works",
  eyebrow = "Get started in 3 steps",
  steps,
  ctaHref,
  ctaText,
  eventName,
}: IHowItWorksProps) => {
  if (!steps.length) return null;
  const handleCtaClick = () => {
    if (eventName) trackEvent(eventName);
  };

  return (
    <StyledSection>
      <div className="inner">
        <header>
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
        </header>
        <ol className="steps">
          {steps.map((s, i) => (
            <li key={s.title} className="step">
              <span className="num" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </li>
          ))}
        </ol>
        {ctaHref && ctaText && (
          <a className="cta" href={ctaHref} onClick={handleCtaClick}>
            {ctaText}
            <span aria-hidden="true">→</span>
          </a>
        )}
      </div>
    </StyledSection>
  );
};
